// extracted by mini-css-extract-plugin
export default {"sectionFooter":"SectionFooter_sectionFooter__beaQd","editText":"SectionFooter_editText__okaTZ","editSymbol":"SectionFooter_editSymbol__xQurN"};